import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取活动列表
export const getAiCallList = params => {
    return post("/admin/botCall/list", params);
};
// 新增
export const addAiCall = params => {
    return post("/admin/botCall/taskAdd", params);
};
// 编辑
export const editAiCall = params => {
    return post("/admin/botCall/edit", params);
};
// 短信策略名称及编号查询
export const getSmsList = params => {
    return get("/admin/botCall/smsStrategyQuery", params);
};
// 状态code及名称下拉查询
export const getStatusList = params => {
    return get("/admin/botCall/getStatusMap", params);
};
// 流程策略名称及编号查询
export const getFlowList = params => {
    return get("/admin/botCall/flowListQuery", params);
};
// 用户电话筛选条件查询
export const getPhoneFilterList = params => {
    return get("/admin/botCall/getFilters", params);
};
// 电call电话个数筛选查询
export const getPhoneCountList = params => {
    return post("/admin/botCall/getMobileCount", params);
};


// 流程策略管理
// 流程策略列表
export const getFlowSmsList = params => {
    return post("/admin/botCall/channelMapList", params);
};
// 添加
export const flowSmsAdd = params => {
    return post("/admin/botCall/channelMapAdd", params);
};
// 编辑
export const flowSmsEdit = params => {
    return post("/admin/botCall/channelMapEdit", params);
};
// 删除
export const flowSmsDel = params => {
    return del(`/admin/botCall/channelMapRemove/${params}`);
};


// 电call、群发短信开关状态查询
export const querySmsStatus = params => {
	return get("/admin/botCall/button", params);
};
// 电call、群发短信开关状态修改
export const switchSmsStatus = params => {
	return get("/admin/botCall/turnButton", params);
};



// WEBPACK FOOTER //
// ./src/api/aiCall.js